// import React, { useEffect, useState, useContext } from "react";
// import "./ResourceManagement.css";
// import baseURL from "../ApiUrl/Apiurl"; 
// import { AuthContext } from "../AuthContext/AuthContext";
// import { useCompany } from "../AuthContext/CompanyContext";
// import { FaEdit, FaTrash } from "react-icons/fa";
// import axios from "axios";
// import Swal from 'sweetalert2';

// const ResourceTable = ({ onAdd, onEdit  }) => { 
//   const [resources, setResources] = useState([]);
//    const { userId, userRole } = useContext(AuthContext);
//   const [filteredResources, setFilteredResources] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//     const { selectedCompany } = useCompany();

//   // Fetch data from API
//     const fetchResources = async () => {
//       try {
//         if (!selectedCompany || !userId) return;

//         const response = await fetch(
//           `${baseURL}/resources/?company_id=${selectedCompany}&user_id=${userId}`
//         );

//         const result = await response.json();
//         if (result.status === "success" && Array.isArray(result.data)) {
//           const sortedData = result.data.sort(
//             (a, b) => new Date(b.created_at) - new Date(a.created_at)
//           );
//           setResources(sortedData);
//           setFilteredResources(sortedData);
//         } else {
//           console.error("Unexpected API response format:", result);
//         }
//       } catch (error) {
//         console.error("Failed to fetch resources:", error);
//       }
//     };


// useEffect(() => {
//     fetchResources();
//   }, [userId, selectedCompany]);


//   useEffect(() => {
//     const filtered = resources.filter((res) =>
//       Object.values(res)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     );
//     setFilteredResources(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, resources]);

// const handleDelete = async (resourceId) => {
//   const result = await Swal.fire({
//     title: 'Are you sure?',
//     text: "You won't be able to revert this!",
//     icon: 'warning',
//     showCancelButton: true,
//     confirmButtonColor: '#d33',
//     cancelButtonColor: '#3085d6',
//     confirmButtonText: 'Yes, delete it!'
//   });

//   if (!result.isConfirmed) return;

//   try {
//     const deleteUrl = `${baseURL}/resources/${resourceId}/?user_id=${userId}&company_id=${selectedCompany}`;
    
//     const response = await axios.delete(deleteUrl, {
//       headers: {
//         'Content-Type': 'application/json',
//       }
//     });

//     if (response.status === 200 || response.status === 204) {
//       await fetchResources();
//       Swal.fire({
//         icon: 'success',
//         title: 'Deleted!',
//         text: 'Resource has been deleted.',
//         confirmButtonColor: '#3085d6',
//       });
//     } else {
//       Swal.fire({
//         icon: 'error',
//         title: 'Failed!',
//         text: `Unexpected response: ${response.status}`,
//         confirmButtonColor: '#3085d6',
//       });
//     }
//   } catch (error) {
//     console.error('Delete error details:', error);

//     let errorMessage = 'Error deleting resource';
//     if (error.response) {
//       errorMessage += `: ${error.response.status} - ${error.response.data?.message || 'No additional details'}`;
//     } else if (error.request) {
//       errorMessage += ': No response received from server';
//     } else {
//       errorMessage += `: ${error.message}`;
//     }

//     Swal.fire({
//       icon: 'error',
//       title: 'Error',
//       text: errorMessage,
//       confirmButtonColor: '#3085d6',
//     });
//   }
// };


//   const formatDateTime = (dateString) => {
//   if (!dateString) return '-';
//   const date = new Date(dateString);

//   return date.toLocaleString('en-IN', {
//     day: '2-digit',
//     month: '2-digit',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     // second: '2-digit',
//     hour12: false,
//     timeZone: 'Asia/Kolkata'
//   });
// }; 


//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentResources = filteredResources.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredResources.length / entriesPerPage);

//   return (
//     <div className="user-management-container">
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
//         <div>
//           <h2 className="user-management-title mb-0">Resource Management</h2>
//           <p className="user-management-subtitle mb-0 text-muted">Manage resource records</p>
//         </div>
//         <button onClick={onAdd} className="btn btn-primary">Add New Resource</button>
//       </div>

//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <div className="d-flex align-items-center gap-2">
//           Show
//           <select
//             value={entriesPerPage}
//             onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//             className="form-select form-select-sm w-auto"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//           </select>
//           entries
//         </div>
//         <input
//           type="text"
//           placeholder="Search resources..."
//           className="form-control w-auto"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       <div className="table-responsive mb-4">
//         <table className="table ">
//           <thead className="product-table-header">
//             <tr>
//               <th>S.No</th>
//               <th>Resource ID</th>
//               <th>user ID</th>
//                <th>Company</th>
//               <th>Full Name</th>
//               <th>Mobile</th>
//               <th>Email</th>
//               <th>Status</th>
//               <th>Hourly Rate</th>
//               <th>Created At</th>
//               <th>Updated At</th>
//               <th>Created By</th>
//               <th>Updated By</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentResources.length > 0 ? (
//               currentResources.map((res, index) => (
//                 <tr key={res.resource_id}>
//                   <td>{indexOfFirstEntry + index + 1}</td>
//                   <td>{res.resource_id}</td>
//                   <td>{res.user}</td>
//                     <td>{res.company}</td>
//                   <td>{res.full_name}</td>
//                   <td>{res.mobile_no}</td>
//                   <td>{res.email}</td>
//                   <td>
//                     <span className={`badge ${
//                       res.status === 'Active' ? 'bg-success' :
//                       res.status === 'Inactive' ? 'bg-warning text-dark' :
//                       'bg-danger'
//                     }`}>
//                       {res.status}
//                     </span>
//                   </td>
//                   <td>{res.hourly_rate}</td>
//                   <td>{formatDateTime(res.created_at)}</td>
//                   <td>{formatDateTime(res.updated_at)}</td>
//                   <td>{res.created_by}</td>
//                   <td>{res.updated_by}</td>
//                   <td>
//                     <FaEdit 
//           className="text-primary me-2" 
//           role="button" 
//           onClick={() => onEdit(res)}  // Add onClick handler
//         />
//                     <FaTrash 
//           className="text-danger" 
//           role="button" 
//           onClick={() => handleDelete(res.resource_id)} 
//         />
//       </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="text-center">No resources found.</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       <div className="pagination-controls d-flex justify-content-center mt-3">
//         <button
//           className="btn btn-outline-primary me-2"
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((prev) => prev - 1)}
//         >
//           Previous
//         </button>
//         <span className="align-self-center mx-2">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="btn btn-outline-primary ms-2"
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((prev) => prev + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ResourceTable;



// import React, { useEffect, useState, useContext } from "react";
// import "./ResourceManagement.css";
// import baseURL from "../ApiUrl/Apiurl"; 
// import { AuthContext } from "../AuthContext/AuthContext";
// import { useCompany } from "../AuthContext/CompanyContext";
// import { FaEdit, FaTrash } from "react-icons/fa";
// import axios from "axios";
// import Swal from 'sweetalert2';

// const ResourceTable = ({ onAdd, onEdit  }) => { 
//   const [resources, setResources] = useState([]);
//   const [users, setUsers] = useState([]);
//   const { userId, userRole } = useContext(AuthContext);
//   const [filteredResources, setFilteredResources] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//   const { selectedCompany } = useCompany();

//   // Fetch users data
//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get(`${baseURL}/users/`);
//       const usersArray = Array.isArray(response.data) ? response.data : [];
//       setUsers(usersArray);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   // Fetch resources data
//   const fetchResources = async () => {
//     try {
//       if (!selectedCompany || !userId) return;

//       const response = await fetch(
//         `${baseURL}/resources/?company_id=${selectedCompany}&user_id=${userId}`
//       );

//       const result = await response.json();
//       if (result.status === "success" && Array.isArray(result.data)) {
//         const sortedData = result.data.sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );
//         setResources(sortedData);
//         setFilteredResources(sortedData);
//       } else {
//         console.error("Unexpected API response format:", result);
//       }
//     } catch (error) {
//       console.error("Failed to fetch resources:", error);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//     fetchResources();
//   }, [userId, selectedCompany]);

//   // Function to get username from user_id
//   const getUsername = (userId) => {
//     if (!userId || users.length === 0) return userId || '-'; // Return user_id if no users data
    
//     const user = users.find(user => user.user_id === userId);
//     return user ? user.username : userId; // Return username if found, otherwise return user_id
//   };

//   useEffect(() => {
//     const filtered = resources.filter((res) =>
//       Object.values(res)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     );
//     setFilteredResources(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, resources]);

//   const handleDelete = async (resourceId) => {
//     const result = await Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       cancelButtonColor: '#3085d6',
//       confirmButtonText: 'Yes, delete it!'
//     });

//     if (!result.isConfirmed) return;

//     try {
//       const deleteUrl = `${baseURL}/resources/${resourceId}/?user_id=${userId}&company_id=${selectedCompany}`;
      
//       const response = await axios.delete(deleteUrl, {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       });

//       if (response.status === 200 || response.status === 204) {
//         await fetchResources();
//         Swal.fire({
//           icon: 'success',
//           title: 'Deleted!',
//           text: 'Resource has been deleted.',
//           confirmButtonColor: '#3085d6',
//         });
//       } else {
//         Swal.fire({
//           icon: 'error',
//           title: 'Failed!',
//           text: `Unexpected response: ${response.status}`,
//           confirmButtonColor: '#3085d6',
//         });
//       }
//     } catch (error) {
//       console.error('Delete error details:', error);

//       let errorMessage = 'Error deleting resource';
//       if (error.response) {
//         errorMessage += `: ${error.response.status} - ${error.response.data?.message || 'No additional details'}`;
//       } else if (error.request) {
//         errorMessage += ': No response received from server';
//       } else {
//         errorMessage += `: ${error.message}`;
//       }

//       Swal.fire({
//         icon: 'error',
//         title: 'Error',
//         text: errorMessage,
//         confirmButtonColor: '#3085d6',
//       });
//     }
//   };

//   const formatDateTime = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);

//     return date.toLocaleString('en-IN', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: false,
//       timeZone: 'Asia/Kolkata'
//     });
//   }; 

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentResources = filteredResources.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredResources.length / entriesPerPage);

//   return (
//     <div className="user-management-container">
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
//         <div>
//           <h2 className="user-management-title mb-0">Resource Management</h2>
//           <p className="user-management-subtitle mb-0 text-muted">Manage resource records</p>
//         </div>
//         <button onClick={onAdd} className="btn btn-primary">Add New Resource</button>
//       </div>

//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <div className="d-flex align-items-center gap-2">
//           Show
//           <select
//             value={entriesPerPage}
//             onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//             className="form-select form-select-sm w-auto"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//           </select>
//           entries
//         </div>
//         <input
//           type="text"
//           placeholder="Search resources..."
//           className="form-control w-auto"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       <div className="table-responsive mb-4">
//         <table className="table ">
//           <thead className="product-table-header">
//             <tr>
//               <th>S.No</th>
//               <th>Resource ID</th>
//               <th>User ID</th>
//               <th>Company</th>
//               <th>Full Name</th>
//               <th>Mobile</th>
//               <th>Email</th>
//               <th>Status</th>
//               <th>Hourly Rate</th>
//               <th>Average Rating</th>
//               <th>Created At</th>
//               {/* <th>Updated At</th> */}
//               <th>Created By</th>
//               {/* <th>Updated By</th> */}
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentResources.length > 0 ? (
//               currentResources.map((res, index) => (
//                 <tr key={res.resource_id}>
//                   <td>{indexOfFirstEntry + index + 1}</td>
//                   <td>{res.resource_id}</td>
//                   <td>{res.user}</td>
//                   <td>{res.company}</td>
//                   <td>{res.full_name}</td>
//                   <td>{res.mobile_no}</td>
//                   <td>{res.email}</td>
//                   <td>
//                     <span className={`badge ${
//                       res.status === 'Active' ? 'bg-success' :
//                       res.status === 'Inactive' ? 'bg-warning text-dark' :
//                       'bg-danger'
//                     }`}>
//                       {res.status}
//                     </span>
//                   </td>
//                   {/* <td>{res.hourly_rate}</td> */}
//                   <td>﷼ {res.hourly_rate}</td>
//                   <td>{res.average_rating}</td>
//                   <td>{formatDateTime(res.created_at)}</td>
//                   {/* <td>{formatDateTime(res.updated_at)}</td> */}
//                   <td>{getUsername(res.created_by)}</td>
//                   {/* <td>{getUsername(res.updated_by)}</td> */}
//                   <td>
//                     <FaEdit 
//                       className="text-primary me-2" 
//                       role="button" 
//                       onClick={() => onEdit(res)}  // Add onClick handler
//                     />
//                     <FaTrash 
//                       className="text-danger" 
//                       role="button" 
//                       onClick={() => handleDelete(res.resource_id)} 
//                     />
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="14" className="text-center">No resources found.</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       <div className="pagination-controls d-flex justify-content-center mt-3">
//         <button
//           className="btn btn-outline-primary me-2"
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((prev) => prev - 1)}
//         >
//           Previous
//         </button>
//         <span className="align-self-center mx-2">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="btn btn-outline-primary ms-2"
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((prev) => prev + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ResourceTable;

//==========================================================================

// After fixing filter -Global search issue 


import React, { useEffect, useState, useContext, useRef } from "react";
import "./ResourceManagement.css";
import baseURL from "../ApiUrl/Apiurl"; 
import { AuthContext } from "../AuthContext/AuthContext";
import { useCompany } from "../AuthContext/CompanyContext";
import { FaEdit, FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from 'sweetalert2';

const ResourceTable = ({ onAdd, onEdit }) => { 
  const [resources, setResources] = useState([]);
  const [users, setUsers] = useState([]);
  const { userId, userRole } = useContext(AuthContext);
  const { selectedCompany } = useCompany();
  
  const [searchTerm, setSearchTerm] = useState(() => {
    return sessionStorage.getItem('resources_searchTerm') || '';
  });
  const [entriesPerPage, setEntriesPerPage] = useState(() => {
    return Number(sessionStorage.getItem('resources_entriesPerPage')) || 5;
  });
  const [currentPage, setCurrentPage] = useState(() => {
    return Number(sessionStorage.getItem('resources_currentPage')) || 1;
  });
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const [error, setError] = useState(null);

  // Refs for managing requests
  const abortControllerRef = useRef(null);
  const initialLoadRef = useRef(true);

  // Session storage effects
  useEffect(() => {
    sessionStorage.setItem('resources_searchTerm', searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    sessionStorage.setItem('resources_entriesPerPage', entriesPerPage);
  }, [entriesPerPage]);

  useEffect(() => {
    sessionStorage.setItem('resources_currentPage', currentPage);
  }, [currentPage]);

  // Fetch users data with pagination
  const fetchUsers = async () => {
    setUsersLoading(true);
    try {
      let allUsers = [];
      let page = 1;
      let hasNext = true;

      while (hasNext) {
        const response = await axios.get(`${baseURL}/users-pagination/`, {
          params: {
            page,
            page_size: 100, // Fetch in chunks
          },
        });

        const pageItems = Array.isArray(response.data.data) ? response.data.data : [];
        allUsers = allUsers.concat(pageItems);

        const pagination = response.data.pagination;
        if (pagination && pagination.has_next && pagination.next_page) {
          page = pagination.next_page;
          hasNext = true;
        } else {
          hasNext = false;
        }
      }

      setUsers(allUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setUsersLoading(false);
    }
  };

  // Fetch resources data with pagination
  const fetchResources = async (page = currentPage, size = entriesPerPage, search = searchTerm, isInitial = false) => {
    // Cancel previous request if any
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    if (!selectedCompany || !userId) {
      setError('Missing user ID or company ID');
      return;
    }

    if (isInitial) {
      setLoading(true);
    } else {
      setFetching(true);
    }
    setError(null);

    abortControllerRef.current = new AbortController();

    try {
      let url = `${baseURL}/resources-pagination/?company_id=${selectedCompany}&user_id=${userId}&page=${page}&page_size=${size}`;
      
      if (search.trim()) {
        url += `&search_query=${encodeURIComponent(search.trim())}`;
      }

      const response = await fetch(url, {
        signal: abortControllerRef.current.signal
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status === "success" && Array.isArray(result.data)) {
        const sortedData = result.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setResources(sortedData);
        setError(null);

        // Update pagination info
        const pagination = result.pagination || {};
        setTotalCount(pagination.total_count || 0);
        setTotalPages(pagination.total_pages || 1);
        setHasNextPage(pagination.has_next || false);
        setCurrentPage(pagination.current_page || 1);
      } else {
        setError(result.message || 'Failed to fetch resources');
        setResources([]);
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
      console.error("Failed to fetch resources:", error);
      setError(error.message || 'Failed to fetch resources');
      setResources([]);
    } finally {
      if (isInitial) {
        setLoading(false);
      } else {
        setFetching(false);
      }
      abortControllerRef.current = null;
    }
  };

  // Initial load - fetch users and resources
  useEffect(() => {
    const loadInitialData = async () => {
      if (!selectedCompany || !userId) return;
      
      setLoading(true);
      try {
        await Promise.all([
          fetchUsers(),
          fetchResources(1, entriesPerPage, '', true)
        ]);
      } catch (error) {
        console.error("Error loading initial data:", error);
        setError('Failed to load initial data');
      } finally {
        setLoading(false);
        initialLoadRef.current = false;
      }
    };

    loadInitialData();

    // Cleanup
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [selectedCompany, userId]);

  // Handle search, filter, and pagination changes
  useEffect(() => {
    if (initialLoadRef.current || !selectedCompany || !userId) return;

    const debounceTimer = setTimeout(() => {
      fetchResources(1, entriesPerPage, searchTerm, false);
    }, 300);

    return () => {
      clearTimeout(debounceTimer);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [searchTerm, entriesPerPage]);

  // Handle page changes
  useEffect(() => {
    if (initialLoadRef.current || !selectedCompany || !userId) return;

    fetchResources(currentPage, entriesPerPage, searchTerm, false);
  }, [currentPage]);

  // Function to get username from user_id
  const getUsername = (userId) => {
    if (!userId || users.length === 0) return userId || '-';
    
    const user = users.find(user => user.user_id === userId);
    return user ? user.username : userId;
  };

  // Function to format date for display
  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);

    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Kolkata'
    });
  };

  const handleDelete = async (resourceId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    });

    if (!result.isConfirmed) return;

    try {
      const deleteUrl = `${baseURL}/resources/${resourceId}/?user_id=${userId}&company_id=${selectedCompany}`;
      
      const response = await axios.delete(deleteUrl, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.status === 200 || response.status === 204) {
        // Refresh current page
        await fetchResources(currentPage, entriesPerPage, searchTerm, false);
        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          text: 'Resource has been deleted.',
          confirmButtonColor: '#3085d6',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: `Unexpected response: ${response.status}`,
          confirmButtonColor: '#3085d6',
        });
      }
    } catch (error) {
      console.error('Delete error details:', error);

      let errorMessage = 'Error deleting resource';
      if (error.response) {
        errorMessage += `: ${error.response.status} - ${error.response.data?.message || 'No additional details'}`;
      } else if (error.request) {
        errorMessage += ': No response received from server';
      } else {
        errorMessage += `: ${error.message}`;
      }

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
        confirmButtonColor: '#3085d6',
      });
    }
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
    sessionStorage.setItem('resources_currentPage', 1);
  };

  const handleEntriesPerPageChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
    sessionStorage.setItem('resources_currentPage', 1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const indexOfFirstEntry = (currentPage - 1) * entriesPerPage;
  const currentResources = resources;

  if (loading || usersLoading) {
    return (
      <div className="user-management-container">
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p>Loading {loading ? 'resources' : 'users'}...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="user-management-container">
        <div className="alert alert-danger my-4">
          {error}
          <button 
            className="btn btn-primary ms-3" 
            onClick={() => fetchResources(currentPage, entriesPerPage, searchTerm, false)}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management-container">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <div>
          <h2 className="user-management-title mb-0">Resource Management</h2>
          <p className="user-management-subtitle mb-0 text-muted">Manage resource records</p>
        </div>
        <button onClick={onAdd} className="btn btn-primary">Add New Resource</button>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <div className="d-flex align-items-center gap-2">
          Show
          <select
            value={entriesPerPage}
            onChange={(e) => handleEntriesPerPageChange(Number(e.target.value))}
            className="form-select form-select-sm w-auto"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
          entries
        </div>
        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            placeholder="Search in all columns..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => handleSearchChange(e.target.value)}
            style={{ minWidth: '250px' }}
          />
          {searchTerm && (
            <button 
              className="btn btn-sm btn-outline-secondary"
              onClick={() => handleSearchChange('')}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Results Summary */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          {searchTerm && (
            <div className="alert alert-info mb-0">
              <strong>Search Results:</strong> Found {totalCount} resource(s) matching "{searchTerm}"
            </div>
          )}
        </div>
        <div className="text-muted small">
          Showing {currentResources.length} of {totalCount} resources
        </div>
      </div>

      <div className="table-responsive mb-4">
        <table className="table">
          <thead className="product-table-header">
            <tr>
              <th>S.No</th>
              <th>Resource ID</th>
              <th>User ID</th>
              <th>Company</th>
              <th>Full Name</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Status</th>
              <th>Hourly Rate</th>
              <th>Average Rating</th>
              <th>Created At</th>
              <th>Created By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {fetching ? (
              <tr>
                <td colSpan="13" className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2 mb-0 text-muted">Loading resources...</p>
                </td>
              </tr>
            ) : currentResources.length > 0 ? (
              currentResources.map((res, index) => (
                <tr key={res.resource_id || index}>
                  <td>{indexOfFirstEntry + index + 1}</td>
                  <td>{res.resource_id}</td>
                  <td>{res.user}</td>
                  <td>{res.company}</td>
                  <td>{res.full_name}</td>
                  <td>{res.mobile_no}</td>
                  <td>{res.email}</td>
                  <td>
                    <span className={`badge ${
                      res.status === 'Active' ? 'bg-success' :
                      res.status === 'Inactive' ? 'bg-warning text-dark' :
                      'bg-danger'
                    }`}>
                      {res.status}
                    </span>
                  </td>
                  <td>﷼ {res.hourly_rate}</td>
                  <td>{res.average_rating || 'N/A'}</td>
                  <td>{formatDateTime(res.created_at)}</td>
                  <td>{getUsername(res.created_by)}</td>
                  <td>
                    <FaEdit 
                      className="text-primary me-2" 
                      role="button" 
                      onClick={() => onEdit(res)}
                      style={{ cursor: 'pointer' }}
                    />
                    <FaTrash 
                      className="text-danger" 
                      role="button" 
                      onClick={() => handleDelete(res.resource_id)}
                      style={{ cursor: 'pointer' }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" className="text-center">
                  {searchTerm ? `No resources found matching "${searchTerm}"` : 'No resources found.'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls d-flex justify-content-center mt-3">
          <button
            className="btn btn-outline-primary me-2"
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            Previous
          </button>
          
          <div className="d-flex align-items-center mx-2">
            {(() => {
              const maxVisiblePages = 5;
              let pageNumbers = [];
              
              if (totalPages <= maxVisiblePages) {
                for (let i = 1; i <= totalPages; i++) {
                  pageNumbers.push(i);
                }
              } else {
                let startPage = Math.max(1, currentPage - 2);
                let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                
                if (endPage - startPage + 1 < maxVisiblePages) {
                  startPage = Math.max(1, endPage - maxVisiblePages + 1);
                }
                
                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(i);
                }
              }
              
              return pageNumbers.map((page) => (
                <button
                  key={page}
                  className={`btn mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              ));
            })()}
          </div>
          
          <span className="align-self-center mx-2">
            Page {currentPage} of {totalPages}
          </span>
          
          <button
            className="btn btn-outline-primary ms-2"
            disabled={!hasNextPage && currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default ResourceTable;